import React, { FunctionComponent, useMemo } from "react";
import { Button } from "../button";
import { GlobalHeaderButtonProps } from "./global-header";
import { CSS_CLASSES } from "./global-header-css-classes";

export interface GlobalHeaderCTAButtonsProps {
  ctaButtons: GlobalHeaderButtonProps[];
  isDesktop: boolean;
}

export const GlobalHeaderCTAButtons: FunctionComponent<GlobalHeaderCTAButtonsProps> = ({
  ctaButtons = [],
  isDesktop,
}) => {
  const ctaButtonsToRender = useMemo(
    () =>
      !isDesktop && ctaButtons.length > 0
        ? ctaButtons.filter(({ placementOnMobile }) => placementOnMobile === "main-header")
        : ctaButtons,
    [ctaButtons, isDesktop]
  );

  const hasCTAButtons = useMemo(() => ctaButtonsToRender.length > 0, [ctaButtonsToRender]);

  return hasCTAButtons ? (
    <div className={CSS_CLASSES.GLOBAL_HEADER_CTA_BUTTONS}>
      {ctaButtonsToRender.map((props, i) => {
        const passthroughProps = { ...props };
        delete passthroughProps.placementOnMobile;
        delete passthroughProps.hideWhenSignedIn;
        return <Button key={passthroughProps.label || i} size={isDesktop ? "medium" : "small"} {...passthroughProps} />;
      })}
    </div>
  ) : null;
};
